import { render, staticRenderFns } from "./ExcellentClass.vue?vue&type=template&id=6a0ff64a&scoped=true&"
import script from "./ExcellentClass.vue?vue&type=script&lang=js&"
export * from "./ExcellentClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0ff64a",
  null
  
)

export default component.exports